import ExperiencePage from "./ExperiencePage";
import { IMG } from "../../i18n/marketingImages";

export default function ExperienceCanal() {
  return <ExperiencePage expKey="canal" image={IMG.vrangfoss} />;
}
